import BrandLogo from "../../../common/ui/BrandLogo.js";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function OrderStatusNavigation(props) {

    return (
        <header className="shadow-sm">
            <div className="container-lg">
                <div className="row">
                    <div className="col-12 row px-0 m-0 align-items-center py-2">
                        <div className="col-sm-3 d-flex justify-content-sm-start justify-content-center align-items-center mb-2 mb-sm-0">
                            <BrandLogo />
                        </div>
                        <div className="col-sm-6 d-grid">
                            <button type="button" className="btn btn-dark rounded-pill" onClick={props.handleStartNewOrderClickOrderStatus} style={{maxHeight: "max-content"}}>
                                Start New Order
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}